import uiRouter from 'angular-ui-router';
import { estimatorDirective } from './estimator.directive';
import { estimatorStore } from './estimator.store';

export const estimator = angular
  .module('estimator', [uiRouter])
  .config($stateProvider => {
    $stateProvider.state('app.estimator', {
      url: '/skip-bins-size-estimator.aspx',
      template: '<estimator></estimator>',
      data: {
        metaTitle: 'Rentaskip Australia | Estimate skip bin sizes',
        metaDescription:
          'Rentaskip - How to estimate the skip bin size you need',
        metaKeywords:
          'Skip Bins,Skip hire, Skip Bin,  bin hire, Skips, Australia Skip Hire'
      }
    });
  })
  .directive('estimator', estimatorDirective)
  .factory('estimatorStore', estimatorStore);



/** WEBPACK FOOTER **
 ** ./src/app/components/estimator/estimator.js
 **/